import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import getComparativeSnapshot from 'api/rates/comparative-snapshot/get-comparative-snapshot';
import {Microclimates} from 'api/rates/comparative-snapshot/comparative-snapshot.types';

interface GetComparativeSnapshotParams {
    facilityId: number;
    onSuccess?: (data: Microclimates) => void;
}

/**
 * Fetches the comparative snapshot data for a given facility.
 *
 * This thunk action creator makes an asynchronous call to the API to retrieve
 * the comparative snapshot data for the specified facility.
 *
 * Action Type: 'facilities/getComparativeSnapshotData'
 *
 * API Service: {@link getComparativeSnapshot}
 */
export const getComparativeSnapshotData = createAsyncThunk<
    Microclimates,
    GetComparativeSnapshotParams
>(
    'facilities/getCompetitiveSnapshotData',
    async ({facilityId}, {rejectWithValue}) => {
        try {
            const response: Microclimates =
                await getComparativeSnapshot(facilityId);

            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
/**
 * Action to handle the microclimate state
 */
export const setMicroclimateKey = createAction(
    'reservations/setMicroclimateKey',
    (microclimateKey: string) => {
        return {
            payload: microclimateKey,
        };
    }
);
